import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  container: {
    // width: 768,
    width: '50vw',
  },
}));
